const AllLanguages = [{ id: '124', name: 'Abkhazian' },
{ id: '235', name: 'Achinese' },
{ id: '236', name: 'Acoli' },
{ id: '237', name: 'Adangme' },
{ id: '125', name: 'Afan (Oromo)' },
{ id: '126', name: 'Afar' },
{ id: '239', name: 'Afrihili (Artifical' },
{ id: '83', name: 'Afrikaans' },
{ id: '238', name: 'Afroasiatic (Other)' },
{ id: '105', name: 'Akan' },
{ id: '240', name: 'Akkadian' },
{ id: '84', name: 'Albanian' },
{ id: '241', name: 'Aleut' },
{ id: '242', name: 'Algonquian (Other)' },
{ id: '513', name: 'Altaic (Other)' },
{ id: '243', name: 'Amharic' },
{ id: '1', name: 'Amheric' },
{ id: '244', name: 'Apache Languages' },
{ id: '2', name: 'Arabic' },
{ id: '245', name: 'Aramaic' },
{ id: '247', name: 'Arapaho' },
{ id: '249', name: 'Arawak' },
{ id: '69', name: 'Armenian' },
{ id: '248', name: 'Artificial (Other)' },
{ id: '3', name: 'Asian' },
{ id: '127', name: 'Assamese' },
{ id: '121', name: 'Assyrian' },
{ id: '250', name: 'Athapascan (Other)' },
{ id: '401', name: 'Austonesian (Other)' },
{ id: '51', name: 'Australian' },
{ id: '251', name: 'Avaric' },
{ id: '252', name: 'Avestan' },
{ id: '253', name: 'Awadhi' },
{ id: '254', name: 'Aymara' },
{ id: '234', name: 'Azerbaijani' },
{ id: '122', name: 'Bahasa Indonesia' },
{ id: '258', name: 'Balinese' },
{ id: '260', name: 'Baltic' },
{ id: '257', name: 'Baluchi' },
{ id: '195', name: 'Bambara' },
{ id: '256', name: 'Bamileke Languages' },
{ id: '255', name: 'Banda' },
{ id: '270', name: 'Bantu (Other)' },
{ id: '259', name: 'Basa' },
{ id: '128', name: 'Bashkir' },
{ id: '129', name: 'Basque' },
{ id: '274', name: 'Batak' },
{ id: '261', name: 'Beja' },
{ id: '262', name: 'Belarusian' },
{ id: '263', name: 'Bemba' },
{ id: '4', name: 'Bengali' },
{ id: '264', name: 'Berber' },
{ id: '265', name: 'Bhopuri' },
{ id: '130', name: 'Bhutani' },
{ id: '1055', name: 'Bihari' },
{ id: '266', name: 'Bikol' },
{ id: '267', name: 'Bini' },
{ id: '268', name: 'Bislama' },
{ id: '35', name: 'Bosnian' },
{ id: '271', name: 'Braj' },
{ id: '272', name: 'Breton' },
{ id: '275', name: 'Bugis' },
{ id: '70', name: 'Bulgarian' },
{ id: '273', name: 'Buriat' },
{ id: '71', name: 'Burmese' },
{ id: '1053', name: 'Byelorussian' },
{ id: '276', name: 'Caddo' },
{ id: '36', name: 'Cambodian' },
{ id: '5', name: 'Cantonese' },
{ id: '279', name: 'Carib' },
{ id: '280', name: 'Catalan' },
{ id: '281', name: 'Caucasian' },
{ id: '68', name: 'Cebuano' },
{ id: '282', name: 'Celtic (Other)' },
{ id: '277', name: 'Central American Ind' },
{ id: '287', name: 'Chagatai' },
{ id: '285', name: 'Chaldean' },
{ id: '294', name: 'Chamic Languages' },
{ id: '283', name: 'Chamorro' },
{ id: '286', name: 'Chechen' },
{ id: '290', name: 'Cherokee' },
{ id: '293', name: 'Cheyenne' },
{ id: '284', name: 'Chibcha' },
{ id: '6', name: 'Chinese' },
{ id: '288', name: 'Chinook Jargon' },
{ id: '289', name: 'Choctaw' },
{ id: '291', name: 'Church Slavic' },
{ id: '292', name: 'Chuvash' },
{ id: '295', name: 'Coptic' },
{ id: '296', name: 'Cornish' },
{ id: '1054', name: 'Corsicann' },
{ id: '297', name: 'Cree' },
{ id: '415', name: 'Creek' },
{ id: '63', name: 'Creole' },
{ id: '562', name: 'Creoles & Pidg (Oth)' },
{ id: '564', name: 'Creoles Pidgin (Eng)' },
{ id: '565', name: 'Creoles Pidgin (Por)' },
{ id: '37', name: 'Croatian' },
{ id: '298', name: 'Cushitic' },
{ id: '38', name: 'Czech' },
{ id: '299', name: 'Dakota' },
{ id: '300', name: 'Damara' },
{ id: '72', name: 'Danish' },
{ id: '87', name: 'Dari' },
{ id: '301', name: 'Dayak' },
{ id: '302', name: 'Delaware' },
{ id: '303', name: 'Dida' },
{ id: '304', name: 'Dinka' },
{ id: '305', name: 'Divehi' },
{ id: '306', name: 'Dogri' },
{ id: '307', name: 'Dravidian' },
{ id: '308', name: 'Duala' },
{ id: '7', name: 'Dutch' },
{ id: '309', name: 'Dutch, Middle (1050-' },
{ id: '196', name: 'Dyula' },
{ id: '106', name: 'Edo' },
{ id: '310', name: 'Efik' },
{ id: '73', name: 'Egyptian' },
{ id: '211', name: 'Ekajuk' },
{ id: '311', name: 'Elamite' },
{ id: '74', name: 'English' },
{ id: '312', name: 'Eskimo Languages' },
{ id: '233', name: 'Esperanto' },
{ id: '313', name: 'Estonian' },
{ id: '61', name: 'Ethiopian' },
{ id: '131', name: 'Ewe' },
{ id: '314', name: 'Ewondo' },
{ id: '315', name: 'Fang' },
{ id: '317', name: 'Fanti' },
{ id: '316', name: 'Faroese' },
{ id: '75', name: 'Farsi' },
{ id: '194', name: 'Fijian' },
{ id: '96', name: 'Fili' },
{ id: '88', name: 'Finnish' },
{ id: '173', name: 'Finno_Ugric' },
{ id: '113', name: 'Flemish' },
{ id: '318', name: 'Fon' },
{ id: '320', name: 'Formosan' },
{ id: '8', name: 'French' },
{ id: '319', name: 'Friesian' },
{ id: '1051', name: 'Frisian' },
{ id: '321', name: 'Friulian' },
{ id: '138', name: 'Fukien' },
{ id: '322', name: 'Fula' },
{ id: '323', name: 'Ga' },
{ id: '111', name: 'Gaelic' },
{ id: '1052', name: 'Galician' },
{ id: '324', name: 'Gallegan' },
{ id: '388', name: 'Ganda' },
{ id: '325', name: 'Gayo' },
{ id: '326', name: 'Gbaya' },
{ id: '327', name: 'Geez' },
{ id: '76', name: 'Georgian' },
{ id: '9', name: 'German' },
{ id: '563', name: 'Germanic' },
{ id: '328', name: 'Gilbertese' },
{ id: '77', name: 'Gola' },
{ id: '329', name: 'Gondi' },
{ id: '330', name: 'Gorontalo' },
{ id: '331', name: 'Gothic' },
{ id: '332', name: 'Grebo' },
{ id: '10', name: 'Greek' },
{ id: '333', name: 'Greenlandic' },
{ id: '135', name: 'Guarani' },
{ id: '39', name: 'Gujarati' },
{ id: '197', name: 'Haida' },
{ id: '103', name: 'Haitian' },
{ id: '117', name: 'Haitian Creole' },
{ id: '575', name: 'Haitian-Haiti Creole' },
{ id: '119', name: 'Hausa' },
{ id: '212', name: 'Hawaiian' },
{ id: '11', name: 'Hebrew' },
{ id: '334', name: 'Herero' },
{ id: '335', name: 'Hiligaynon' },
{ id: '336', name: 'Himachali' },
{ id: '12', name: 'Hindi' },
{ id: '338', name: 'Hiri Motu' },
{ id: '337', name: 'Hmong' },
{ id: '40', name: 'Hungarian' },
{ id: '339', name: 'Hupa' },
{ id: '340', name: 'Iban' },
{ id: '112', name: 'Ibo' },
{ id: '89', name: 'Icelandic' },
{ id: '107', name: 'Igbo' },
{ id: '341', name: 'Ijo' },
{ id: '100', name: 'Ilocano' },
{ id: '342', name: 'Iloko' },
{ id: '13', name: 'Indian' },
{ id: '343', name: 'Indic' },
{ id: '344', name: 'Indo-European (Other' },
{ id: '41', name: 'Indonesian' },
{ id: '172', name: 'Interlingua' },
{ id: '152', name: 'Interpreters Avail.' },
{ id: '345', name: 'Inuktitut' },
{ id: '346', name: 'Inupiak' },
{ id: '42', name: 'Iranian' },
{ id: '347', name: 'Irish' },
{ id: '348', name: 'Iroquoian (Other)' },
{ id: '90', name: 'Israeli' },
{ id: '14', name: 'Italian' },
{ id: '15', name: 'Japanese' },
{ id: '349', name: 'Javanese' },
{ id: '351', name: 'Judeo-Arabic' },
{ id: '350', name: 'Judeo-Persian' },
{ id: '352', name: 'Kabyle' },
{ id: '171', name: 'Kachin' },
{ id: '353', name: 'Kamba' },
{ id: '16', name: 'Kannada' },
{ id: '356', name: 'Kanuri' },
{ id: '368', name: 'Kara-Kalpac' },
{ id: '354', name: 'Karen' },
{ id: '355', name: 'Kashmiri' },
{ id: '78', name: 'Kashmirian' },
{ id: '371', name: 'Kashubian' },
{ id: '357', name: 'Kawi' },
{ id: '358', name: 'Kazakh' },
{ id: '359', name: 'Khasi' },
{ id: '278', name: 'Khmer' },
{ id: '360', name: 'Khoisan (Other)' },
{ id: '361', name: 'Khotanese' },
{ id: '232', name: 'Kikuyu' },
{ id: '364', name: 'Kimbundu' },
{ id: '362', name: 'Kinyarwanda' },
{ id: '1049', name: 'Kirghiz' },
{ id: '365', name: 'Komi' },
{ id: '366', name: 'Kongo' },
{ id: '104', name: 'Konkani' },
{ id: '17', name: 'Korean' },
{ id: '367', name: 'Kpelle' },
{ id: '369', name: 'Kru' },
{ id: '372', name: 'Kuanyama' },
{ id: '373', name: 'Kurdish' },
{ id: '370', name: 'Kurukh' },
{ id: '1050', name: 'Kurundi' },
{ id: '374', name: 'Kusaie' },
{ id: '375', name: 'Kutenai' },
{ id: '363', name: 'Kyrgyz' },
{ id: '376', name: 'Ladino' },
{ id: '377', name: 'Lahnd' },
{ id: '378', name: 'Lamba' },
{ id: '379', name: 'Langue d oc' },
{ id: '380', name: 'Lao' },
{ id: '43', name: 'Laotian' },
{ id: '381', name: 'Lapp' },
{ id: '44', name: 'Latin' },
{ id: '108', name: 'Latvian' },
{ id: '45', name: 'Lebanese' },
{ id: '385', name: 'Letzeburgesch' },
{ id: '393', name: 'Lezghian' },
{ id: '382', name: 'Lingala' },
{ id: '18', name: 'Lithuanian' },
{ id: '384', name: 'Lozi' },
{ id: '387', name: 'Luba-Katanga' },
{ id: '386', name: 'Luba-Lulua' },
{ id: '389', name: 'Luiseno' },
{ id: '390', name: 'Lunda' },
{ id: '391', name: 'Luo (Kenya and Tanza' },
{ id: '392', name: 'Lushai' },
{ id: '91', name: 'Macedonian' },
{ id: '394', name: 'Madurese' },
{ id: '395', name: 'Magahi' },
{ id: '397', name: 'Maithali' },
{ id: '398', name: 'Makasar' },
{ id: '231', name: 'Malagasy' },
{ id: '109', name: 'Malay' },
{ id: '60', name: 'Malayalam' },
{ id: '46', name: 'Malayan' },
{ id: '408', name: 'Maltese' },
{ id: '47', name: 'Maltse' },
{ id: '48', name: 'Mandarin' },
{ id: '399', name: 'Mandingo' },
{ id: '409', name: 'Manipuri' },
{ id: '410', name: 'Manobo Languages' },
{ id: '403', name: 'Manx' },
{ id: '400', name: 'Maori' },
{ id: '246', name: 'Mapuche' },
{ id: '49', name: 'Marathi' },
{ id: '396', name: 'Marshall' },
{ id: '416', name: 'Marwari' },
{ id: '402', name: 'Masai' },
{ id: '418', name: 'Mayan Languages' },
{ id: '404', name: 'Mende' },
{ id: '405', name: 'Micmac' },
{ id: '406', name: 'Minangkabau' },
{ id: '417', name: 'Mixteco' },
{ id: '411', name: 'Mohawk' },
{ id: '192', name: 'Moldavian' },
{ id: '407', name: 'Mon-Khmer (Other)' },
{ id: '383', name: 'Mongo-Nkundu' },
{ id: '412', name: 'Mongolian' },
{ id: '413', name: 'Moore' },
{ id: '414', name: 'Munda' },
{ id: '133', name: 'Nahua' },
{ id: '419', name: 'Nahuatl' },
{ id: '198', name: 'Nauru' },
{ id: '50', name: 'Navajo' },
{ id: '420', name: 'Ndebele (Zimbabwe)' },
{ id: '421', name: 'Ndonga' },
{ id: '99', name: 'Nepali' },
{ id: '422', name: 'Newari' },
{ id: '423', name: 'Nias' },
{ id: '424', name: 'Niger-Kordofanian' },
{ id: '79', name: 'Nigerian' },
{ id: '427', name: 'Nilo-Saharan' },
{ id: '483', name: 'Nilo-Saharan (Other)' },
{ id: '425', name: 'Niuean' },
{ id: '213', name: 'North Amer Indian' },
{ id: '428', name: 'Northern Sotho' },
{ id: '80', name: 'Norwegian' },
{ id: '429', name: 'Nubian Languages' },
{ id: '431', name: 'Nyamwezi' },
{ id: '430', name: 'Nyanja' },
{ id: '432', name: 'Nyankole' },
{ id: '433', name: 'Nyoro' },
{ id: '434', name: 'Nzima' },
{ id: '1048', name: 'Occitan' },
{ id: '435', name: 'Ojibwa' },
{ id: '426', name: 'Old Norse' },
{ id: '447', name: 'Old Persian (600-400' },
{ id: '98', name: 'Oriya' },
{ id: '437', name: 'Osage' },
{ id: '438', name: 'Ossetic' },
{ id: '440', name: 'Otomian Languages' },
{ id: '436', name: 'Ovambo' },
{ id: '443', name: 'Pahlavi' },
{ id: '19', name: 'Pakistani' },
{ id: '446', name: 'Palauan' },
{ id: '448', name: 'Pali' },
{ id: '444', name: 'Pampanga' },
{ id: '442', name: 'Pangasinan' },
{ id: '445', name: 'Papiamento' },
{ id: '441', name: 'Papuan-Australian (O' },
{ id: '101', name: 'Pashto' },
{ id: '92', name: 'Pashtun' },
{ id: '52', name: 'Persian' },
{ id: '20', name: 'Phillipina' },
{ id: '21', name: 'Polish' },
{ id: '449', name: 'Ponape' },
{ id: '53', name: 'Portuguese' },
{ id: '450', name: 'Prakrit Languages' },
{ id: '451', name: 'Provencal (to 1500)' },
{ id: '54', name: 'Punjabi' },
{ id: '452', name: 'Pushto' },
{ id: '453', name: 'Quechua' },
{ id: '454', name: 'Rajasthani' },
{ id: '455', name: 'Rapanui' },
{ id: '456', name: 'Rarotongan' },
{ id: '458', name: 'Rhaeto-Romance' },
{ id: '457', name: 'Romance (Other)' },
{ id: '22', name: 'Romanian' },
{ id: '459', name: 'Romany' },
{ id: '460', name: 'Rundi' },
{ id: '23', name: 'Russian' },
{ id: '464', name: 'Salishan Languages' },
{ id: '465', name: 'Samaritan Aramaic' },
{ id: '114', name: 'Samoan' },
{ id: '461', name: 'Sandawe' },
{ id: '469', name: 'Sandawe (Other)' },
{ id: '462', name: 'Sango' },
{ id: '1045', name: 'Sangro' },
{ id: '93', name: 'Sanskrit' },
{ id: '467', name: 'Santali' },
{ id: '132', name: 'Sara' },
{ id: '481', name: 'Sardinian' },
{ id: '466', name: 'Sasak' },
{ id: '94', name: 'Scandinavian' },
{ id: '1046', name: 'Scot Gaelic' },
{ id: '214', name: 'Scots' },
{ id: '470', name: 'Selkup' },
{ id: '471', name: 'Semitic (Other)' },
{ id: '55', name: 'Serbian' },
{ id: '56', name: 'Serbo-Croatian' },
{ id: '468', name: 'Serbo-Croatian (Cyri' },
{ id: '482', name: 'Serer' },
{ id: '1047', name: 'Sesotho' },
{ id: '1043', name: 'Setswana' },
{ id: '472', name: 'Shan' },
{ id: '473', name: 'Shona' },
{ id: '474', name: 'Sidamo' },
{ id: '24', name: 'Sign Language' },
{ id: '269', name: 'Siksika' },
{ id: '81', name: 'Sindhi' },
{ id: '136', name: 'Sinhala' },
{ id: '82', name: 'Sinhalese' },
{ id: '476', name: 'Sino-Tibetan (Other)' },
{ id: '475', name: 'Siouan (Other)' },
{ id: '1044', name: 'Siswati' },
{ id: '25', name: 'Slavic' },
{ id: '477', name: 'Slovak' },
{ id: '137', name: 'Slovenian' },
{ id: '479', name: 'Sogdian' },
{ id: '134', name: 'Somali' },
{ id: '480', name: 'Songhai' },
{ id: '478', name: 'Soninke' },
{ id: '529', name: 'Sorbian Languages' },
{ id: '484', name: 'Sotho' },
{ id: '463', name: 'South American India' },
{ id: '26', name: 'Spanish' },
{ id: '27', name: 'Sri Lankan' },
{ id: '485', name: 'Sukuma' },
{ id: '487', name: 'Sumerian' },
{ id: '215', name: 'Sundanese' },
{ id: '486', name: 'Susu' },
{ id: '62', name: 'Swahili' },
{ id: '488', name: 'Swazi' },
{ id: '28', name: 'Swedish' },
{ id: '489', name: 'Sylheti' },
{ id: '490', name: 'Syriac' },
{ id: '29', name: 'Syrian' },
{ id: '30', name: 'Tagalog' },
{ id: '115', name: 'Tahitian' },
{ id: '64', name: 'Taiwanese' },
{ id: '491', name: 'Tajik' },
{ id: '501', name: 'Tamang' },
{ id: '502', name: 'Tamashek' },
{ id: '31', name: 'Tamil' },
{ id: '65', name: 'Tarkish' },
{ id: '492', name: 'Tatar' },
{ id: '57', name: 'Telugu' },
{ id: '493', name: 'Temne' },
{ id: '494', name: 'Terena' },
{ id: '495', name: 'Tetum' },
{ id: '32', name: 'Thai' },
{ id: '496', name: 'Tibetan' },
{ id: '191', name: 'Tigre' },
{ id: '497', name: 'Tigrinya' },
{ id: '503', name: 'Timne' },
{ id: '498', name: 'Tiv' },
{ id: '500', name: 'Tlingit' },
{ id: '507', name: 'Tok Pisin' },
{ id: '499', name: 'Tokelauan' },
{ id: '505', name: 'Tonga (Nyasa)' },
{ id: '506', name: 'Tonga (Tonga Islands' },
{ id: '116', name: 'Tongan' },
{ id: '508', name: 'Truk' },
{ id: '504', name: 'Tsimshian' },
{ id: '509', name: 'Tsonga' },
{ id: '510', name: 'Tswana' },
{ id: '512', name: 'Tumbuka' },
{ id: '67', name: 'Turkish' },
{ id: '439', name: 'Turkish, Ottoman' },
{ id: '511', name: 'Turkmen' },
{ id: '514', name: 'Tuvalu' },
{ id: '110', name: 'Twi' },
{ id: '120', name: 'Ugandan' },
{ id: '515', name: 'Ugaritic' },
{ id: '516', name: 'Uighur' },
{ id: '1041', name: 'Uigur' },
{ id: '97', name: 'Ujarati' },
{ id: '33', name: 'Ukranian' },
{ id: '517', name: 'Umbundu' },
{ id: '518', name: 'Undetermined' },
{ id: '519', name: 'Unknown' },
{ id: '1040', name: 'Uraq' },
{ id: '58', name: 'Urdu' },
{ id: '520', name: 'Uzbek' },
{ id: '522', name: 'Vai' },
{ id: '521', name: 'Vai (Other)' },
{ id: '523', name: 'Venda' },
{ id: '59', name: 'Vietnamese' },
{ id: '1042', name: 'Volapuk' },
{ id: '524', name: 'Votic' },
{ id: '525', name: 'Wakashan Languages' },
{ id: '526', name: 'Walamo' },
{ id: '527', name: 'Waray' },
{ id: '528', name: 'Washo' },
{ id: '123', name: 'Welsh' },
{ id: '530', name: 'Woleaian' },
{ id: '199', name: 'Wolof' },
{ id: '193', name: 'Xhosa' },
{ id: '200', name: 'Yakut' },
{ id: '531', name: 'Yao (Bantu)' },
{ id: '532', name: 'Yapese' },
{ id: '34', name: 'Yiddish' },
{ id: '102', name: 'Yoruba' },
{ id: '95', name: 'Yugoslav' },
{ id: '66', name: 'Yunisian' },
{ id: '535', name: 'Zande' },
{ id: '533', name: 'Zapotec' },
{ id: '534', name: 'Zenaga' },
{ id: '536', name: 'Zhuang (Chuang)' },
{ id: '118', name: 'Zulu' },
{ id: '537', name: 'Zuni' }
];

export default AllLanguages;